// extracted by mini-css-extract-plugin
export default {"table":"style_table__5J2nI","table__empty":"style_table__empty__x-w4U"};